import { render } from "./FlexMessageBubble.vue?vue&type=template&id=663481e1&scoped=true"
import script from "./FlexMessageBubble.vue?vue&type=script&lang=ts"
export * from "./FlexMessageBubble.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-663481e1"

export default script